import { gql } from "@apollo/client";

export const GET_APP_CONFIG_QUERY = gql`
  query GetAppConfig {
    appConfig {
      volumeDefault
      volumeMax
      volumeStep
    }
  }
`;
